// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ship-from[data-v-06913886]{grid-area:ship-from}", ""]);
// Exports
module.exports = exports;
